/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';

/**
* Individual billing transaction record representing a specific billing event
*/
export class BillingTransactionHistory {
  /**
  * Unique identifier for the billing transaction record. 
  */
  'id': string;
  /**
  * Marketplace account ID associated with this transaction. References the cloud provider\'s marketplace account (AWS, Azure, or GCP). 
  */
  'marketplaceAccountId': string;
  /**
  * Number of credits consumed in this billing transaction. Represents the credit amount deducted from the customer\'s balance. 
  */
  'usedCredits': number;
  /**
  * EON usage amount for this transaction in the marketplace\'s native units. Represents the actual usage that may be charged through the marketplace. 
  */
  'eonUsage': number;
  /**
  * Number of credits added in this transaction. Populated for: - CONTRACT_SIGNED: Credits from the signed marketplace agreement - REFUND: Credits returned to the customer For all other transaction types, this field will be 0. 
  */
  'addedCredits'?: number;
  /**
  * Type of billing transaction indicating the nature of the billing event: - `empty_billing_transaction`: Placeholder transaction with no financial impact - `contract_signed`: Transaction created when a marketplace agreement/contract is signed - `credit_usage`: Transaction for consuming prepaid credits - `marketplace_charge`: Direct charge through the cloud marketplace - `credit_usage_and_marketplace_charge`: Combined transaction with both credit usage and marketplace charge - `refund`: Refund transaction for returned credits or charges 
  */
  'transactionType': BillingTransactionHistoryTransactionTypeEnum;
  /**
  * Marketplace agreement or subscription ID associated with this transaction. Populated for CONTRACT_SIGNED and CREDIT_USAGE transaction types when credits are consumed from an agreement. For AWS: references AwsMarketplaceAgreement ID For Azure: references AzureMarketplaceSubscription ID   For GCP: references GcpMarketplaceAgreement ID 
  */
  'marketplaceAgreementId'?: string;
  /**
  * Marketplace refund ID associated with this transaction. Populated for REFUND transaction types and CREDIT_USAGE when credits are consumed from a refund. References the MarketplaceRefund ID. 
  */
  'marketplaceRefundId'?: string;
  /**
  * Timestamp when the billing transaction occurred. Represents the exact time the billing event was processed. 
  */
  'billingTime': Date;
  'cloudProvider': Provider;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "marketplaceAccountId",
      "baseName": "marketplaceAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "usedCredits",
      "baseName": "usedCredits",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "eonUsage",
      "baseName": "eonUsage",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "addedCredits",
      "baseName": "addedCredits",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "transactionType",
      "baseName": "transactionType",
      "type": "BillingTransactionHistoryTransactionTypeEnum",
      "format": ""
    },
    {
      "name": "marketplaceAgreementId",
      "baseName": "marketplaceAgreementId",
      "type": "string",
      "format": ""
    },
    {
      "name": "marketplaceRefundId",
      "baseName": "marketplaceRefundId",
      "type": "string",
      "format": ""
    },
    {
      "name": "billingTime",
      "baseName": "billingTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BillingTransactionHistory.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum BillingTransactionHistoryTransactionTypeEnum {
  EmptyBillingTransaction = 'EMPTY_BILLING_TRANSACTION',
  ContractSigned = 'CONTRACT_SIGNED',
  CreditUsage = 'CREDIT_USAGE',
  MarketplaceCharge = 'MARKETPLACE_CHARGE',
  CreditUsageAndMarketplaceCharge = 'CREDIT_USAGE_AND_MARKETPLACE_CHARGE',
  Refund = 'REFUND',
  TransactionTypeUnspecified = 'TRANSACTION_TYPE_UNSPECIFIED'
}

